import { render } from "./AsHeader.vue?vue&type=template&id=5f26042c&ts=true"
import script from "./AsHeader.vue?vue&type=script&lang=ts"
export * from "./AsHeader.vue?vue&type=script&lang=ts"

import "./AsHeader.vue?vue&type=style&index=0&id=5f26042c&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__